var Model = require('../Model');
var model = Object.create(Model);

model.name = 'RestHttp';
model['@class'] = 'RestHttp';
model.url = 'resthttp';
model.parentClass = 'Host';
model.isNetworkModel = true;

model.fields = {
  enabled: {
    type: 'switch',
    default: 0,
  },
  name: {
    type: 'text',
    default: null,
    validators: {
      presence: true,
      length: {minimum: 3, maximum: 128}
    }
  },
  host: {
    type: 'text',
    default: null,
    validators : {
      presence: true
    }
  },
  port: {
    type: 'text',
    default: null,
    validators : {
      emptyOrNumeric: true,
    }
  },
  apiRoot: {
    type: 'text',
    default: '/',
    validators : {
      presence: true
    }
  },
  status: {
    default: 'unknown',
  },
  error: {
    default: null,
  },
  authType: {
    default: '',
    hidden: true
  },
  bearerToken: {
    default: '',
    hidden: true
  },
  headers: {
    default: '',
    hidden: true
  },
  timeout: {
    default: '',
    hidden: true
  },
  followRedirect: {
    default: '',
    hidden: true
  },
  gzip: {
    default: '',
    hidden: true
  },
  strictSSL: {
    default: '',
    hidden: true
  },
  proxy: {
    default: '',
    hidden: true
  },
  requestOptions: {
    default: '',
    hidden: true
  },
  responseFormat: {
    default: '',
    hidden: true
  },
  xml: {
    type: 'select',
    default: 0,
    options: [
      {name: 'Parse as JSON', value: 0},
      {name: 'Parse as XML', value: 1},
    ]
  },
  html: {
    type: 'select',
    default: 0,
    options: [
      {name: 'Parse as JSON', value: 0},
      {name: 'Parse as HTML', value: 1},
    ]
  },
  authMethod: {
    type: 'select',
    default : 'get',
    options: [
      {name: 'GET', value: 'get'},
      {name: 'POST', value: 'post'}
    ]
  },
  preAuthUrl: {
    type: 'text',
    default: ''
  },
  authUrl: {
    type: 'text',
    default: ''
  },
  username: {
    type: 'text',
    default: null,
  },
  password: {
    type: 'password',
    default: null,
  },
  useSession: {
    type: 'select',
    default: 0,
    options: [
      {name: 'True', value: 1},
      {name: 'False', value: 0},
    ]
  },
  nameField: {
    type: 'text',
    default: null,
  },
  passField: {
    type: 'text',
    default: null,
  }
};
  
module.exports = model;
